// theme/_woocommerce.js
export function initWooVariations() {
	if (!document.body.classList.contains('single-product')) return;
	const $ = window.jQuery;
	if (!$ || !$.fn) return;

	waitFor(() => $.fn.wc_variation_form, 50, 40).then(() => {
		const $forms = $('.variations_form');
		if (!$forms.length) return;

		$forms.each(function () {
			const $form = $(this);

			// Init Woo's variation engine
			if ($form.data('wc_variation_form') === undefined) {
				$form.wc_variation_form();
			}

			// Clear any selected values (works with the PHP filter too)
			$form.find('select').each(function(){
				this.value = '';
			});

			// Initial sync
			syncUIFromSelects($form);
			updateAvailability($form);

			// Bind button/swatches click handlers
			bindGroup($form, '.variation-buttons', '.variation-btn');
			bindGroup($form, '.acf-color-swatches', '.acf-color-swatch');
		});

		// React to Woo events and select changes
		$('.variations_form')
			.on('change', 'select', function(){
				const $form = $(this).closest('.variations_form');
				syncUIFromSelects($form);
				updateAvailability($form);
			})
			.on('reset_data', function(){
				const $form = $(this);
				$form.find('.acf-color-swatch, .variation-btn').removeClass('active');
				updateAvailability($form); // re-enable everything
			})
			.on('click', '.reset_variations', function(){
				const $form = $(this).closest('.variations_form');
				$form.find('select').val('').trigger('change');
			});
	}).catch(() => {});
}

// --- helpers ------------------------------------------------------

function waitFor(testFn, interval = 50, attempts = 40) {
	return new Promise((resolve, reject) => {
		const t = setInterval(() => {
			if (testFn()) { clearInterval(t); resolve(); }
			else if (--attempts <= 0) { clearInterval(t); reject(); }
		}, interval);
	});
}

function bindGroup($form, wrapperSel, btnSel) {
	const $ = window.jQuery;
	$form.find(wrapperSel).each(function(){
		const $wrap   = $(this);
		const $select = $wrap.next('select');
		if (!$select.length) return;
		$select.hide();

		$wrap.off('click.wooVar', btnSel).on('click.wooVar', btnSel, function(e){
			e.preventDefault();
			const $btn = $(this);
			const val  = $btn.data('value');

			// Toggle: clicking active clears value
			if ($btn.hasClass('active')) {
				$wrap.find(btnSel).removeClass('active');
				$select.val('');
			} else {
				$wrap.find(btnSel).removeClass('active');
				$btn.addClass('active');
				$select.val(val);
			}

			$select.trigger('change'); // lets Woo update price/image/ATC
		});
	});
}

function syncUIFromSelects($form) {
	const $ = window.jQuery;
	$form.find('select').each(function(){
		const $sel = $(this);
		const val  = $sel.val();
		const $wrap = $sel.prev('.acf-color-swatches, .variation-buttons');
		if (!$wrap.length) return;

		$wrap.find('.acf-color-swatch, .variation-btn').removeClass('active');
		if (val) {
			$wrap.find(`[data-value="${CSS.escape(val)}"]`).addClass('active');
		}
	});
}

/**
 * Disable only the options that cannot exist given current selections.
 * Uses Woo's data-product_variations to compute valid remaining values per attribute.
 */
function updateAvailability($form) {
	const $ = window.jQuery;
	const variations = $form.data('product_variations') || [];
	const selected = currentSelections($form); // { 'attribute_pa_colour': 'black', ... }

	// For each select (attribute), figure out which values are possible
	$form.find('select').each(function(){
		const $sel = $(this);
		const attrName = $sel.attr('name'); // e.g. 'attribute_pa_capacity'

		// Build a filter of all *other* selected attrs
		const others = {};
		Object.keys(selected).forEach(key => {
			if (key !== attrName && selected[key]) others[key] = selected[key];
		});

		// Derive the set of enabled values for this attr based on other selections
		const enabled = new Set();
		variations.forEach(v => {
			const ok = Object.entries(others).every(([k, val]) => v.attributes[k] === val);
			if (ok) {
				const val = v.attributes[attrName];
				if (val) enabled.add(val);
			}
		});

		// If nothing selected elsewhere, enable everything present in variations
		if (Object.keys(others).length === 0) {
			variations.forEach(v => {
				const val = v.attributes[attrName];
				if (val) enabled.add(val);
			});
		}

		// Apply disabled state to buttons/swatches for this attribute
		const $wrap = $sel.prev('.acf-color-swatches, .variation-buttons');
		if ($wrap.length) {
			$wrap.find('.acf-color-swatch, .variation-btn').each(function(){
				const $btn = $(this);
				const v = $btn.data('value');
				$btn.toggleClass('is-disabled', v && !enabled.has(v));
			});
		}

		// Mirror on the hidden <select> (optional)
		$sel.find('option').each(function(){
			const optVal = this.value;
			if (!optVal) return; // skip "Choose an option"
			this.disabled = !enabled.has(optVal);
		});
	});
}

function currentSelections($form) {
	const $ = window.jQuery;
	const data = {};
	$form.find('select').each(function(){
		const name = this.name;
		const val  = this.value || '';
		data[name] = val;
	});
	return data;
}
